import React from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { GamstopPreviouslyPositiveState } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.state';
import {
    GamstopPreviouslyPositiveCommunicationChannelDescription,
    GamstopPreviouslyPositiveCommunicationChannelInner,
    GamstopPreviouslyPositiveCommunicationChannelOption,
    GamstopPreviouslyPositiveCommunicationChannelOptions,
    GamstopPreviouslyPositiveCommunicationChannelSection,
    GamstopPreviouslyPositiveCommunicationChannelTitle,
    GamstopPreviouslyPositiveCommunicationChannelWrapper,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.style';

interface GamstopPreviouslyPositiveCommunicationChannelPanelPropsType {
    state: GamstopPreviouslyPositiveState;
    isVisible: boolean;
}

export const GamstopPreviouslyPositiveCommunicationChannelPanel = observer(
    ({ state, isVisible }: GamstopPreviouslyPositiveCommunicationChannelPanelPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveCommunicationChannelWrapper
                $isVisible={isVisible}
                data-test='gamstop-pp-communication-channel-wrapper'
            >
                <GamstopPreviouslyPositiveCommunicationChannelInner>
                    <GamstopPreviouslyPositiveCommunicationChannelSection data-test='gamstop-pp-communication-channel'>
                        <GamstopPreviouslyPositiveCommunicationChannelTitle>
                            Communication channel
                        </GamstopPreviouslyPositiveCommunicationChannelTitle>
                        <GamstopPreviouslyPositiveCommunicationChannelDescription>
                            Optionally send additional communication when the selected action runs. Leave unchecked to
                            skip.
                        </GamstopPreviouslyPositiveCommunicationChannelDescription>
                        <GamstopPreviouslyPositiveCommunicationChannelOptions>
                            <GamstopPreviouslyPositiveCommunicationChannelOption as='div'>
                                <Checkbox
                                    dataTest='gamstop-pp-communication-send-email'
                                    isBackground
                                    isChecked={state.sendEmailEnabled}
                                    isDisabled={false}
                                    labelSide='right'
                                    onChange={(): void => {
                                        state.setSendEmailEnabled(!state.sendEmailEnabled);
                                    }}
                                >
                                    <div style={{ marginLeft: '10px' }}>Send email</div>
                                </Checkbox>
                            </GamstopPreviouslyPositiveCommunicationChannelOption>
                            <GamstopPreviouslyPositiveCommunicationChannelOption as='div'>
                                <Checkbox
                                    dataTest='gamstop-pp-communication-send-popup'
                                    isBackground
                                    isChecked={state.sendPopupEnabled}
                                    isDisabled={false}
                                    labelSide='right'
                                    onChange={(): void => {
                                        state.setSendPopupEnabled(!state.sendPopupEnabled);
                                    }}
                                >
                                    <div style={{ marginLeft: '10px' }}>Show popup</div>
                                </Checkbox>
                            </GamstopPreviouslyPositiveCommunicationChannelOption>
                        </GamstopPreviouslyPositiveCommunicationChannelOptions>
                    </GamstopPreviouslyPositiveCommunicationChannelSection>
                </GamstopPreviouslyPositiveCommunicationChannelInner>
            </GamstopPreviouslyPositiveCommunicationChannelWrapper>
        );
    }
);
